import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  Divider
} from '@mui/material';
import { motion } from 'framer-motion';
import image1 from "../../assets/updatedBannerImage/blogcard1.jpg";
import image2 from "../../assets/updatedBannerImage/blogcard2.jpg";
import image3 from "../../assets/updatedBannerImage/blogcard3.jpg";
import reefImage from "../../assets/updatedBannerImage/blogbanner.jpg";

const blogPosts = [
  {
    title: "The Future of Front-End: React's Role in 2025",
    description: "Explore how React is shaping the modern web experience with hooks, server components, and concurrent features.",
    image: image1,
    link: "#"
  },
  {
    title: "Design Meets Code: UI Trends with Material UI",
    description: "Discover how Material UI enables design-first development with accessibility and responsiveness in mind.",
    image: image2,
    link: "#"
  },
  {
    title: "Animate Like a Pro: Using Framer Motion in React",
    description: "Learn how to craft smooth, responsive animations to enhance user engagement using Framer Motion.",
    image: image3,
    link: "#"
  },
  // {
  //   title: "REEF: Bridging Science, Education & Conservation",
  //   description: `The Research and Environmental Education Foundation (REEF) is a non-profit dedicated to advancing environmental stewardship through research, education, and community engagement. Focused on marine and coastal ecosystems, REEF empowers communities, builds local capacity, and collaborates with institutions to foster conservation, sustainability, and resilience.`,
  //   image: reefImage,
  //   link: "#"
  // }
];

const BlogShowcase = () => {

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <Box sx={{ px: 4, py: 8, backgroundColor: '#ffff' }}>
      <Typography variant="h4" gutterBottom align="center" fontWeight="bold" sx={{fontFamily: "Montserrat, sans-serif",}}>
        Latest Blog Insights
      </Typography>
      <Divider sx={{ width: '60px', height: '4px', backgroundColor: '#1976d2', mx: 'auto', mb: 6, borderRadius: 2 }} />
      <Grid container spacing={4} justifyContent="center">
        {blogPosts.map((post, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: 'easeOut' }}
              viewport={{ once: true }}
            >
              <Card
                elevation={4}
                sx={{
                  borderRadius: 4,
                  overflow: 'hidden',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 6px 20px rgba(0,0,0,0.1)'
                  }
                }}
              >
                <CardMedia
                  component="img"
                  height="220"
                  image={post.image}
                  alt={post.title}
                />
                <CardContent>
                  <Typography variant="h6" fontWeight="bold" gutterBottom sx={{fontFamily: "Montserrat, sans-serif",}}>
                    {post.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ minHeight: '80px',fontFamily: "Montserrat, sans-serif", }}>
                    {post.description}
                  </Typography>
                  <Button
                    variant="outlined"
                    sx={{ mt: 2, textTransform: 'none',fontFamily: "Montserrat, sans-serif", }}
                    href={post.link}
                  >
                    Read More →
                  </Button>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default BlogShowcase;
